import { formatBytes } from './util.js';
/**
 * Anomaly heuristics: unusually many deletions/modifications or abnormal growth. Not ransomware detection.
 * Every check needs a baseline of previously backed-up items: a computer's first backup uploads
 * everything, which is expected, not unusual.
 *
 * Shared so the `suspicious_change` alert (server) and the assistant's view of a saved backup apply the
 * same rule, and never disagree about what "unusual" means.
 */
export function assessChange(change, bytesNew, bytesTotal) {
    const prev = change.unchanged + change.modified + change.deleted;
    const reasons = [];
    if (prev < 200)
        return reasons;
    if (change.deleted / prev > 0.3)
        reasons.push(`${change.deleted} of ${prev} previously backed-up items disappeared (${Math.round((100 * change.deleted) / prev)}%)`);
    if (change.modified / prev > 0.5)
        reasons.push(`${change.modified} of ${prev} files changed (${Math.round((100 * change.modified) / prev)}%)`);
    if (bytesTotal > 1 << 30 && bytesNew > bytesTotal * 0.6)
        reasons.push(`unusual upload growth: ${formatBytes(bytesNew)} new of ${formatBytes(bytesTotal)}`);
    return reasons;
}
//# sourceMappingURL=change.js.map